import { render, staticRenderFns } from "./ErrorReportList.vue?vue&type=template&id=53e3de44&scoped=true"
import script from "./ErrorReportList.vue?vue&type=script&lang=js"
export * from "./ErrorReportList.vue?vue&type=script&lang=js"
import style0 from "./ErrorReportList.vue?vue&type=style&index=0&id=53e3de44&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e3de44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53e3de44')) {
      api.createRecord('53e3de44', component.options)
    } else {
      api.reload('53e3de44', component.options)
    }
    module.hot.accept("./ErrorReportList.vue?vue&type=template&id=53e3de44&scoped=true", function () {
      api.rerender('53e3de44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/postScreening/errorReport/ErrorReportList.vue"
export default component.exports